import Modal from "react-responsive-modal";
import { RelatorioFisicoFinanceiro } from "../../../model/PrestacaoDeContas/RelatorioFisicoFinanceiro";
import styles from "./styles.module.css";
import { useState } from "react";
import ModalRelatorioFinanceiro from "../../../components/ModalForms/ModalRelatorioFinanceiro";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";

const ExecucaoFisicoFinanceira = () => {
  const [showAddRelatorio, setAddRelatorio] = useState(false);
  const [showEditRelatorio, setEditRelatorio] = useState(-1);
  const [relatorios, setRelatorios] = useState<RelatorioFisicoFinanceiro[]>([
    {
      etapa: 1,
      fase: 1,
      descricao:
        "Custeio das atividades desenvolvidas pelo Aquidauanense Futebol Clube no âmbito Municipal, Estadual, Federal e na Confederação Brasileira de Futebol",
      unidade_medida: "Unidade",

      executado: 40,
      programado: 40,

      relatorio_financeiro: {
        receita: {
          concedente: 10,
          executor: 20,
          outra: 10,
        },
        despesa: {
          naturezaDespesa: "3.3.50.43.99",
          concedente: 10,
          executor: 20,
          outra: 10,
        },
      },
    },
  ]);
  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          2. Relatório de Execução <strong>Fisico-Financeiro</strong>:
        </h2>

        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2}>ETAPA/FASE</TableCell>
                  <TableCell rowSpan={2}>DESCRIÇÃO</TableCell>
                  <TableCell rowSpan={2}>UNIDADES DE MEDIDA</TableCell>
                  <TableCell colSpan={2}>
                    QUANTIDADE EXECUTADA NO PERIODO
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>PROGRAMADO</TableCell>
                  <TableCell>EXECUTADO</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {relatorios.map((relatorio, index) => (
                  <>
                    <TableRow
                      key={index}
                      hover
                      role="checkbox"
                      sx={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditRelatorio(index);
                      }}
                    >
                      <TableCell>
                        {relatorio.etapa}.{relatorio.fase}
                      </TableCell>
                      <TableCell>{relatorio.descricao}</TableCell>
                      <TableCell align="center">
                        {relatorio.unidade_medida}
                      </TableCell>
                      <TableCell align="center">
                        {relatorio.programado}
                      </TableCell>
                      <TableCell align="center">
                        {relatorio.executado}
                      </TableCell>
                    </TableRow>
                    <Modal
                      open={showEditRelatorio === index}
                      onClose={() => {
                        setEditRelatorio(-1);
                      }}
                      center
                      classNames={{
                        modal: "customModal",
                      }}
                    >
                      <ModalRelatorioFinanceiro
                        closeModal={() => setEditRelatorio(-1)}
                        setList={setRelatorios}
                        list={relatorios}
                        index={index}
                        refRelatorio={relatorio}
                      />
                    </Modal>
                  </>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={5}></TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>

          <div className={styles.addDiv}>
            <button
              className={styles.addBtn}
              onClick={(e) => {
                e.preventDefault();
                setAddRelatorio(true);
              }}
            >
              + Adicionar Meta
            </button>
          </div>
          <Modal
            open={showAddRelatorio}
            onClose={() => setAddRelatorio(false)}
            center
            classNames={{
              modal: "customModal",
            }}
          >
            <ModalRelatorioFinanceiro
              closeModal={() => setAddRelatorio(false)}
              setList={setRelatorios}
              list={relatorios}
            />
          </Modal>
        </div>
      </div>
    </form>
  );
};
export default ExecucaoFisicoFinanceira;
